// Turns a dictated treatment plan into steps. Speech recognition delivers a
// phrase per pause; a phrase can still hold several steps joined by "then",
// so it is split again at sentence ends and at the connecting words of the
// four UI languages. Commas are kept: "krunica, cirkonijum" is one step.

const CONNECTORS = [
  // sr
  'nakon toga',
  'posle toga',
  'pa onda',
  'i onda',
  'zatim',
  'onda',
  // hu
  'ezt követően',
  'ezután',
  'utána',
  'aztán',
  'majd',
  // en
  'after that',
  'and then',
  'then',
  // nb
  'etter det',
  'deretter',
  'og så',
];

/** Not a letter or digit (JS `\b` only knows ASCII, so "og så" or "ondašnji" need this). */
const EDGE_BEFORE = '(?<![\\p{L}\\p{N}])';
const EDGE_AFTER = '(?![\\p{L}\\p{N}])';

/**
 * Words that only number the steps and are dropped. The adverbs ("prvo",
 * "először", "først") go wherever they start a step; the English ordinals only
 * when punctuation follows, so "first molar" stays a tooth.
 */
const ORDINALS = new RegExp(
  `^(?:(?:prvo|drugo|tre[cć]e|[cč]etvrto|peto|el[oő]sz[oö]r|m[aá]sodszor|harmadszor|f[oø]rst|for det f[oø]rste|korak\\s+\\d+|step\\s+\\d+|\\d+[.)])${EDGE_AFTER}|(?:first|second|third|fourth|fifth)(?=\\s*[,:.]))[\\s,:.-]*`,
  'iu'
);

const escapeRegExp = (s: string) => s.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
const SPLIT = new RegExp(
  `[.;!?\\n]+|\\s*,?\\s*${EDGE_BEFORE}(?:${CONNECTORS.map(escapeRegExp).join('|')})${EDGE_AFTER}\\s*,?\\s*`,
  'iu'
);

function tidy(step: string): string {
  const text = step
    .trim()
    .replace(ORDINALS, '')
    .replace(/\s+/g, ' ')
    .trim()
    .replace(/[,:-]+$/, '')
    .trim();
  return text ? text.charAt(0).toLocaleUpperCase() + text.slice(1) : '';
}

/** "1. ", "2) " at the start of the text or of a sentence: numbering, not a sentence end. */
const NUMBERED = /(^|[.;!?\n]\s*)\d+[.)]\s+/gu;

/** The steps in `text`, in order, without empty ones. */
export function splitPlanSteps(text: string): string[] {
  return text.replace(NUMBERED, '$1').split(SPLIT).map(tidy).filter(Boolean);
}
